import { Injectable } from '@angular/core';
import { NetworkService } from "../../common/network.service";


@Injectable({
  providedIn: 'root'
})
export class AboutService {

  constructor(private _networkService: NetworkService) { }


 
  saveAbout(body:any) {
    return this._networkService.post("api/settings", body, null, "bearer")
  }
  getAbout(query) {
    return this._networkService.get("api/settings?"+query, null, null, "bearer")
  }


}
